"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "predappio": {
    "160d2302": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "skipSearch": false
    }],
    "colmano": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "c17da3c7": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "skipSearch": false
    }],
    "fiordinano": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "19cb602c": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "skipSearch": false
    }],
    "marsignano": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bd874774": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "skipSearch": false
    }],
    "monte-colombo": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a60d2cb9": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "skipSearch": false
    }],
    "monte-mirabello": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "be13fcbd": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "skipSearch": false
    }],
    "montemaggiore": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "69cd1eea": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "skipSearch": false
    }],
    "porcentico": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "9698a2b6": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "skipSearch": false
    }],
    "riggiano": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bab03000": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "skipSearch": false
    }],
    "rocca-delle-caminate": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "2d88bcea": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "skipSearch": false
    }],
    "san-cassiano-in-pennino": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a61fdcee": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "skipSearch": false
    }],
    "san-cristoforo": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8d009c7d": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "skipSearch": false
    }],
    "sant-agostino": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "3999c3df": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "skipSearch": false
    }],
    "santa-lucia": [{
      "hkey": "fea23cd6",
      "slug": "predappio",
      "name": "Predappio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;